import http from 'plugins/axios';

export default {
  getRecords(data) {
    return http.get({
      url: '/la/admin/foundation/getOrderListByUid',
      data
    });
  }
};
